import { ReactElement } from 'react';

const AdminDepartments = (): ReactElement => {


  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">
        Department Management
      </h1>
      
      <div className="text-center py-12">
        <div className="text-gray-500 text-lg">
          Department management interface will be implemented here
        </div>
      </div>
    </div>
  );
};

export default AdminDepartments;
